import { render } from "./AddWarehouseUser.vue?vue&type=template&id=5c7e60a6"
import script from "./AddWarehouseUser.vue?vue&type=script&lang=js"
export * from "./AddWarehouseUser.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__